import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { absoluteUrl } from '../../utils/url';
import { getImageByWidth } from '../../utils/api';
import { updateMetaData } from '../../actions/metaDataActions';
import { setFullHeight } from '../../actions/uiActions';
import asyncComponent from '../../utils/async';
import ContainerDimensions from 'react-container-dimensions';
import ModalRouter from '../ModalRouter';


const AsyncPinMap = asyncComponent(() => import('../PinMap'));

class PinMapTitle extends Component {
  constructor (props) {
    super(props);
    this.state = {
      modalItems: {},
    };
    this.modalRef = null;

    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleClickOutsideModal = this.handleClickOutsideModal.bind(this);
    this.setMetaData = this.setMetaData.bind(this);
    this.setMapContainerRef = this.setMapContainerRef.bind(this);
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { mapItems } = nextProps;
    const modalItems = mapItems.reduce((result, item) => {
      const imageMedia = item.media.find(m => m.type === 'image');
      const imageVersion = imageMedia && getImageByWidth(imageMedia.versions, 800);
      const imageCaption = imageMedia && imageMedia.longDescription;
      const imageCredit = imageMedia && imageMedia.credit;
      result[item.slug] = {
        title: item.name,
        body: item.description,
        videos: item.media.filter(m => m.type === 'video').map(m => {
          const thumbnail = getImageByWidth(m.previewImages.posterFrame, 600);
          return {
            title: m.name,
            slug: m.slug,
            body: m.longDescription,
            vimeoId: m.metadata.sourceId,
            vimeoUrl: m.metadata.sourceUrl,
            thumbnail: thumbnail ? thumbnail.url : null,
          };
        }),
        image: imageVersion ? imageVersion.url : null,
        imageCaption,
        imageCredit,
      };
      return result;
    }, {});
    return { modalItems };
  }

  componentDidMount () {
    const { actions, location, match } = this.props;
    this.setMetaData();
    actions.setFullHeight(true);

    // Handle redirecting to a "default" item if one is specified
    if (location.pathname === match.url) {
      this.redirectToDefault();
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { location, history } = this.props;
    if (history.location.pathname !== prevProps.history.location.pathname || location.pathname !== prevProps.location.pathname) {
      clearTimeout(this.modalCloseTimeout);
    }
  }

  componentWillUnmount () {
    clearTimeout(this.modalCloseTimeout);
    this.setMetaData(true);
  }

  handleModalOpen (routeProps, item) {
    const { title, body, image } = item;
    const { actions } = this.props;
    const url = absoluteUrl(routeProps.match.url);
    actions.updateMetaData({
      page: {
        url,
        title,
        description: body,
        ...(image ? { image: absoluteUrl(image) } : {}),
      },
    });
  }

  handleModalClose () {
    this.setMetaData();
  }

  handleClickOutsideModal (e) {
    const { history, match } = this.props;
    // Only trigger this behavior if the click is inside the map container element
    if (this.mapContainerRef && this.mapContainerRef.contains(e.target)) {
      this.modalCloseTimeout = setTimeout(() => history.push(match.url), 150);
    }
  }

  setMetaData (reset = false) {
    const { actions, match, name, description } = this.props;
    const url = absoluteUrl(match.url);
    actions.updateMetaData({
      page: reset ? {} : { title: name, description, url },
    });
  }

  setMapContainerRef (node) {
    this.mapContainerRef = node;
  }

  redirectToDefault () {
    const { history, match, defaultItemId, mapItems } = this.props;
    const defaultItem = mapItems.find(m => m.uid === defaultItemId);
    if (defaultItem) {
      const url = `${match.url}/${defaultItem.slug}`;
      history.push(url);
    }
  }

  render () {
    const { breakpoint, history, location, actions, match, ...rest } = this.props;
    const { modalItems } = this.state;
    if (!Object.keys(modalItems).length) {
      return null;
    }
    const activeItemSlug = location.pathname.replace(match.path, '').replace('/', '') || null;

    if (!AsyncPinMap) {
      return null;
    }

    return (
      <ContainerDimensions>
        {({ width, height }) => {
          const modalStyles = breakpoint.lessThan.lg ? undefined : {
            overlay: {
              position: 'absolute',
              pointerEvents: 'none',
              left: 350,
              top: window.innerHeight - height,
              right: 0,
              bottom: 0,
              background: 'transparent',
            },
            content: {
              position: 'absolute',
            },
          };

          return (
            <ModalRouter
              items={modalItems}
              baseUrl={match.url}
              onModalOpen={this.handleModalOpen}
              onModalClose={this.handleModalClose}
              modalStyles={modalStyles}
              onClickOutsideModal={this.handleClickOutsideModal}
            >
              <AsyncPinMap
                breakpoint={breakpoint}
                baseUrl={match.url}
                activeItemSlug={activeItemSlug}
                mapContainerRef={this.setMapContainerRef}
                {...rest}
              />
            </ModalRouter>
          );
        }}
      </ContainerDimensions>
    );
  }
}

PinMapTitle.propTypes = {
  uid: PropTypes.string.isRequired,
};

PinMapTitle.defaultProps = {
  mapItems: [],
};

const mapStateToProps = ({ breakpoint }) => ({ breakpoint });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updateMetaData, setFullHeight }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PinMapTitle));



// WEBPACK FOOTER //
// ./src/components/Title/PinMapTitle.js